import { render, staticRenderFns } from "./lkuCoa.vue?vue&type=template&id=fc9924da"
import script from "./lkuCoa.vue?vue&type=script&lang=js"
export * from "./lkuCoa.vue?vue&type=script&lang=js"
import style0 from "./lkuCoa.vue?vue&type=style&index=0&id=fc9924da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports